var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warehouse-remain" },
    [
      _c("CompassButton", {
        attrs: {
          label: _vm.$t.__("common.actions.delete"),
          type: "primary-destructive"
        },
        on: { click: _vm.openList }
      }),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "ml-2 mt-2",
        attrs: {
          label: _vm.$t.__("stock.WarehouseRemain.edit"),
          type: "primary",
          onclick: "StockWareHouse.editOne('" + _vm.warehouseId + "')"
        }
      }),
      _vm._v(" "),
      _c("CompassDialog", {
        attrs: {
          visible: _vm.showModal,
          size: "large",
          title: _vm.$t.__("stock.WarehouseRemain.remaining_product")
        },
        on: {
          "update:visible": function($event) {
            _vm.showModal = $event
          },
          "before-close": _vm.handleClose
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__default" }, [
                  _c(
                    "p",
                    {
                      staticClass: "grey typographies-paragraph-medium-regular"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Vous devez supprimer les stocks avant de pouvoir supprimer un entrepôt"
                            )
                          ) +
                          "\n                    "
                      ),
                      _c("br")
                    ]
                  ),
                  _vm._v(" "),
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "loader-container prelative mt-5" },
                        [_c("preloader", { attrs: { display: true } })],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "form well well-no-shadow counter-customisation"
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.items }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "stock.WarehouseRemain.product"
                                  )
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "?_f=catalogueitem&id=" +
                                                scope.row.itemid +
                                                "&type=item&declid=" +
                                                scope.row.declid
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(scope.row.name) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "qt",
                                  label: _vm.$t.__(
                                    "stock.WarehouseRemain.stock_quantity"
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "bookedqt",
                                  label: _vm.$t.__(
                                    "stock.WarehouseRemain.reserved_quantity"
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.close"),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.showModal = false
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }